import useAlias from '@hooks/useAlias';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import FilterCascade from './components/FilterCascade';
import ResultsGrid from './components/ResultsGrid';
import SearchBar from './components/SearchBar';
import SelectionActions from './components/SelectionActions';
import {
  DataPointSearchProvider,
  useDataPointSearchActions,
} from './context/DataPointSearchContext';
import {
  closeButtonSx,
  dialogContentSx,
  dialogPaperSx,
  dialogTitleSx,
  StyledDialogHeader,
} from './DataPointSearch.styles';
import { DataPointSearchModalProps } from './types';

interface ModalContentProps extends DataPointSearchModalProps {}

const DataPointSearchModalContent: React.FC<ModalContentProps> = ({
  open,
  onClose,
  onAddDataPoints,
}) => {
  const alias = useAlias();
  const { resetState } = useDataPointSearchActions();

  useEffect(() => {
    if (!open) {
      resetState();
    }
  }, [open, resetState]);

  const handleClose = () => {
    resetState();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth='xl'
      PaperProps={{ sx: dialogPaperSx }}
    >
      <StyledDialogHeader>
        <Typography variant='h6' sx={dialogTitleSx}>
          {alias('Datapoint Search')}
        </Typography>
        <IconButton onClick={handleClose} sx={closeButtonSx}>
          <CloseIcon />
        </IconButton>
      </StyledDialogHeader>

      <DialogContent dividers sx={dialogContentSx}>
        <FilterCascade />
        <SearchBar />
        <ResultsGrid isModalOpen={open} />
      </DialogContent>

      <SelectionActions onClose={onClose} onAddDataPoints={onAddDataPoints} />
    </Dialog>
  );
};

const DataPointSearchModal: React.FC<DataPointSearchModalProps> = (props) => {
  return (
    <DataPointSearchProvider>
      <DataPointSearchModalContent {...props} />
    </DataPointSearchProvider>
  );
};

export default DataPointSearchModal;
